import { formatMoney } from "../../../shared/utils";
import AttachmentList from "./AttachmentList";
import DateTime from "./DateTime";
import LabeledContainer from "./LabeledContainer";
import PillLabel from "./PillLabel";
import ResponsiveTable from "./ResponsiveTable";


export default function LoanPaymentsTable({ payments }) {
   return <LabeledContainer label="Payments" className="rounded-lg p-4 h-[400px]">
      <ResponsiveTable
         fullHeight
         cols={[
            {
               field: 'amount',
               caption: 'AMOUNT',
               render: amount => formatMoney(amount),
            },
            {
               field: 'type',
               caption: 'TYPE',
               render: type =>  type && <PillLabel>{type.replace(/[-_]/g, ' ').toUpperCase()}</PillLabel>
            },
            {
               field: 'due_at',
               caption: 'DUE DATE',
               render: date => <DateTime value={date} dateOnly />
            },
            {
               field: 'paid',
               caption: 'STATUS',
               render: (paid, row) => {

                  let bgClass, date;

                  if (paid) {
                     bgClass = 'bg-green-600';
                     date = row.paid_at
                  } else if (row.overdue) {
                     bgClass = 'bg-red-600';
                     date = row.due_at;
                  } else {
                     bgClass = 'bg-yellow-600';
                     date = row.due_at;
                  }

                  return <DateTime value={date} dateOnly className={`${bgClass} text-white`} />
                     
               }
            },
            {
               field: 'attachments',
               caption: 'ATTACHMENTS',
               render: attachments => attachments?.length > 0 && <AttachmentList
                  attachments={attachments}
                  variant="list"
                  className="max-w-40"
               />
            }
         ]}
         rows={payments}
      />
   </LabeledContainer>
}